module.exports = __webpack_public_path__ + "img/jednakost.4db18b76.png";